/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Partner information returned to the UI
 * @export
 * @interface PartnerSearchResponse
 */
export interface PartnerSearchResponse {
    /**
     * Global partner ID
     * @type {string}
     * @memberof PartnerSearchResponse
     */
    globalPartnerId?: string;
    /**
     * Technical UUID of the partner
     * @type {string}
     * @memberof PartnerSearchResponse
     */
    techId?: string;
    /**
     * Partner type
     * @type {string}
     * @memberof PartnerSearchResponse
     */
    partnerType?: string;
    /**
     * Whether imported from another system
     * @type {boolean}
     * @memberof PartnerSearchResponse
     */
    imported?: boolean;
    /**
     * Main domicile country
     * @type {string}
     * @memberof PartnerSearchResponse
     */
    mainDomicileCountry?: string;
    /**
     * Full name
     * @type {string}
     * @memberof PartnerSearchResponse
     */
    fullName?: string;
}

/**
 * Check if a given object implements the PartnerSearchResponse interface.
 */
export function instanceOfPartnerSearchResponse(value: object): value is PartnerSearchResponse {
    return true;
}

export function PartnerSearchResponseFromJSON(json: any): PartnerSearchResponse {
    return PartnerSearchResponseFromJSONTyped(json, false);
}

export function PartnerSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'globalPartnerId': json['globalPartnerId'] == null ? undefined : json['globalPartnerId'],
        'techId': json['techId'] == null ? undefined : json['techId'],
        'partnerType': json['partnerType'] == null ? undefined : json['partnerType'],
        'imported': json['imported'] == null ? undefined : json['imported'],
        'mainDomicileCountry': json['mainDomicileCountry'] == null ? undefined : json['mainDomicileCountry'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function PartnerSearchResponseToJSON(json: any): PartnerSearchResponse {
    return PartnerSearchResponseToJSONTyped(json, false);
}

export function PartnerSearchResponseToJSONTyped(value?: PartnerSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'globalPartnerId': value['globalPartnerId'],
        'techId': value['techId'],
        'partnerType': value['partnerType'],
        'imported': value['imported'],
        'mainDomicileCountry': value['mainDomicileCountry'],
        'fullName': value['fullName'],
    };
}

